<template>
	<v-dialog persistent width="auto" v-model="dialog" v-if="selectedDocument">
		<v-card
			style="min-height: 60vh; max-height: 80vh; width: 33vw; min-width: 400px"
			class="overflow-auto d-flex flex-column">
			<v-card-title class="card-header text-left fixed-card-title2">
				<v-row no-gutters>
					<v-col class="align-center d-flex" cols="10">
						<v-toolbar-title>{{ $t('release-note/manual') }}</v-toolbar-title>
					</v-col>
					<v-spacer />
					<v-icon @click="$emit('closeDialog')" color="white">mdi-close</v-icon>
				</v-row>
			</v-card-title>
			<v-card-text class="pa-4 flex-grow-1 d-flex flex-column overflow-auto" style="background-color: #f9f9f9">
				<div class="flex-grow-1">
					<v-row dense class="ma-0">
						<v-col cols="12" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('organization') }}:</div>
							<div class="text-body-1">{{ getOrganizationName(selectedDocument.dedicatedToOrganizationId) }}</div>
						</v-col>
						<v-col cols="12" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('file-name') }}:</div>
							<div class="text-body-1">{{ selectedDocument.fileName }}</div>
						</v-col>
						<v-col cols="12" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('description') }}:</div>
							<div class="text-body-1" style="white-space: pre-wrap">{{ selectedDocument.documentDescription }}</div>
						</v-col>
					</v-row>
				</div>
			</v-card-text>
			<v-card-actions>
				<v-row dense class="ma-0">
					<v-col cols="auto" class="text-left">
						<span class="text-subtitle-1 font-weight-bold">{{ $t('uploaded-at') }}:</span>
						<span class="text-body-1">{{ formatTimestamp(selectedDocument.uploadedAt, 'datetime_med') }}</span>
					</v-col>
					<v-spacer />
					<v-col cols="3" class="text-right">
						<div class="text-subtitle-1 font-weight-bold">{{ selectedDocument.typeOfDocument }}</div>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import { formatTimestamp } from '@/utils/utilities';
import { mapState } from 'vuex';
export default {
	name: 'ReleaseNoteDialog',
	props: ['dialog', 'selectedDocument'],
	computed: {
		...mapState({
			medicalInstitutions: (state) => state.medicalInstitutions.medicalInstitutions,
		}),
	},
	methods: {
		formatTimestamp,
		getOrganizationName (id) {
			if (!id) return this.$t('all');
			const organization = this.medicalInstitutions.find((org) => org.id === id);
			return organization ? organization.institutionName : '';
		},
	},
};
</script>
